var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.721 27.701",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3393"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1279"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#62cbc9",
    d: "M23.946 9.921H13.938c-.028 0-.053-.008-.079-.008a3.941 3.941 0 00-3.93 3.93v9.929a3.941 3.941 0 003.93 3.929h.161a3.78 3.78 0 003.769-3.769v-6.15h6a3.941 3.941 0 003.929-3.93v-.161a3.78 3.78 0 00-3.772-3.77z",
    "data-name": "Path 546"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00698b",
    d: "M13.858 0h-.161a3.78 3.78 0 00-3.769 3.769v6.15h-6a3.941 3.941 0 00-3.93 3.93v.158a3.78 3.78 0 003.769 3.769h10.008c.026 0 .053.008.08.008a3.941 3.941 0 003.93-3.93V3.926a3.941 3.941 0 00-3.93-3.927z",
    "data-name": "Path 547"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5e1e6",
    d: "M13.858 9.913a3.941 3.941 0 00-3.93 3.93v3.938h3.851c.026 0 .051.008.079.008a3.941 3.941 0 003.93-3.93V9.921h-3.855c-.022 0-.049-.008-.075-.008z",
    "data-name": "Path 548"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointments);
export default __webpack_public_path__ + "static/media/appointments.2ed41688.svg";
export { ForwardRef as ReactComponent };